import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";

const schools = [
  {
    title: "Fahrschule Bergedorf",
    address: [
      {
        title: "Alte Holstenstraße 23<br/>21031 Hamburg",
        link: "https://maps.app.goo.gl/ZW8Q87y671JdjbRi7",
      },
      {
        title: "Alte Holstenstraße 29<br/>21031 Hamburg",
        link: "https://maps.app.goo.gl/VkoQoHh37YvTYJh7A",
      },
    ],
    link: "https://fahrschule-bergedorf.de/",
    images: ["/new/fb_main_new.jpg", "/new/fb_map.jpg"],
  },
  {
    title: "Fahrschule Hafencity",
    address: [
      {
        title: "Baakenallee 90<br/>20457 Hamburg",
        link: "https://maps.app.goo.gl/tC3Aqusbiwje6Q797",
      },
    ],
    link: "https://fahrschule-hafencity.de/",
    images: ["/new/fh_main_new.jpg", "/new/fh_map.jpg"],
  },
  {
    title: "Fahrschule Geesthacht",
    address: [
      {
        title:
          "Bergedorfer Straße 34<br/>Im Geesthachter Hof<br/>21502 Geesthacht",
        link: "https://maps.app.goo.gl/LHDtzhXXirPwfjzK7",
      },
    ],
    link: "https://www.geesthacht-fahrschule.de/",
    images: ["/new/gf_main_new.jpg", "/new/gf_map.jpg"],
  },
];

export default function OurSchoolsBlock({ className = "" }) {
  const pathname = window.location.href;
  return (
    <section
      className={`layout__color_primary position-relative overflow-hidden ${className}`}
    >
      <Container fluid>
        <Row>
          <Col md={12} lg={7} xl={6} className="mb-5 mb-xl-0">
            <h2 data-aos="fade-up">
              {"Wir sind an folgenden Standorten für dich da:"}
            </h2>
          </Col>
          {/* <Col xs={12} md={10} lg={5} xl={5} className="offset-xl-1">
            <div className="layout_text">
              <p data-aos="fade-up" className="mb-xl-4">
                Besuchen Sie unsere Fahrschulen in Bergedorf, HafenCity und
                Geesthacht!
              </p>
              <p data-aos="fade-up">
                Genießen Sie hochwertigen Fahrunterricht und professionelle
                Unterstützung an jedem Standort.
              </p>
            </div>
          </Col> */}

          <Col xs={12} className="layout_mt_new">
            <Splide
              hasTrack={false}
              options={{
                type: "slide",
                start: 0,
                perPage: Math.min(3, schools.length),
                perMove: 1,
                gap: "20px",
                autoWidth: false,
                pagination: false,
                rewind: false,
                arrows: schools.length > 3,
                drag: schools.length > 3,
                breakpoints: {
                  1200: {
                    perPage: Math.min(2, schools.length),
                    autoWidth: true,
                    drag: true,
                    arrows: schools.length > 2,
                  },
                  575: {
                    perPage: 1,
                    autoWidth: true,
                    drag: true,
                    arrows: schools.length > 1,
                  },
                },
              }}
              aria-label="Our Schools"
              className="d-flex flex-column splide_schools"
            >
              <SplideTrack className="overflow-visible">
                {schools.map((school, index) => {
                  return (
                    <SplideSlide data-aos="fade-up" key={`review_${index}`}>
                      <div
                        className={`school_item h-100 d-flex flex-column ${"school_item_" + (index + 1)}`}
                      >
                        <div className="d-flex gap-2 school_item_img">
                          {school.images.slice(0, 2).map((img, index) => (
                            <img
                              src={img}
                              alt={school.title}
                              key={index}
                              className="w-100"
                            />
                          ))}
                        </div>
                        <div className="school_item_content">
                          <div>
                            <h3 className="layout_title layout_title__subitem text-uppercase fw-400 mb-3">
                              {school.title}
                            </h3>
                            <div className="d-flex flex-column gap-12 mb-3">
                              {school.address.map((item, index) => (
                                <a
                                  href={item.link}
                                  target="_blank"
                                  rel="noreferrer"
                                  key={index}
                                  className="d-flex align-items-center justify-content-between gap-2 link-address"
                                >
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: item.title,
                                    }}
                                  ></span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="56"
                                    height="56"
                                    viewBox="0 0 56 56"
                                    fill="none"
                                    className="flex-shrink-0"
                                  >
                                    <rect
                                      width="56"
                                      height="56"
                                      rx="28"
                                      fill="white"
                                    />
                                    <path
                                      d="M29.8607 17.3367C29.097 17.0957 28.2786 16.9639 27.433 16.9639C24.9644 16.9639 22.7549 18.0777 21.2773 19.8326L25.0735 23.0241L29.8607 17.3367Z"
                                      fill="#1A73E8"
                                    />
                                    <path
                                      d="M21.2767 19.8325C20.0596 21.2781 19.3929 23.1074 19.3945 24.9971C19.3945 26.5065 19.6946 27.734 20.1901 28.8296L25.0728 23.024L21.2767 19.8325Z"
                                      fill="#EA4335"
                                    />
                                    <path
                                      d="M27.4331 21.9285C28.0191 21.929 28.5928 22.097 29.0866 22.4127C29.5804 22.7283 29.9736 23.1785 30.2201 23.7102C30.4666 24.2419 30.5561 24.8329 30.4779 25.4137C30.3998 25.9945 30.1573 26.5409 29.779 26.9885L34.5617 21.3011C33.58 19.4097 31.8875 17.9855 29.8563 17.3413L25.0781 23.0287C25.366 22.6839 25.7262 22.4067 26.1332 22.2165C26.5401 22.0264 26.9839 21.9281 27.4331 21.9285Z"
                                      fill="#4285F4"
                                    />
                                    <path
                                      d="M27.4317 28.0752C25.7359 28.0752 24.3584 26.6977 24.3584 25.0019C24.3564 24.2799 24.611 23.5806 25.0767 23.0288L20.1895 28.8344C21.026 30.6847 22.4126 32.1714 23.8401 34.0445L29.7776 26.9886C29.4891 27.3295 29.1298 27.6032 28.7246 27.7909C28.3194 27.9786 27.8782 28.0756 27.4317 28.0752Z"
                                      fill="#FBBC04"
                                    />
                                    <path
                                      d="M29.6604 35.9674C32.3427 31.7757 35.466 29.8708 35.466 24.9972C35.466 23.6606 35.1387 22.4013 34.5613 21.292L23.8457 34.0443C24.3003 34.6399 24.7595 35.2718 25.205 35.9719C26.8326 38.4906 26.3825 39.9999 27.4327 39.9999C28.4829 39.9999 28.0328 38.486 29.6604 35.9674Z"
                                      fill="#34A853"
                                    />
                                  </svg>
                                </a>
                              ))}
                            </div>
                          </div>
                          <div>
                            {pathname.includes(school.link) ? (
                              <Link
                                to="/kontakt"
                                target="_top"
                                className="school_item_link"
                              >
                                Kontakt
                              </Link>
                            ) : (
                              <a
                                href={school.link}
                                target="_blank"
                                rel="noreferrer"
                                className="school_item_link"
                              >
                                Webseite besuchen
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    </SplideSlide>
                  );
                })}
              </SplideTrack>
              <div
                className={`gap-6 items-center mx-auto justify-between newSplide
                    ${schools.length > 3 ? "d-flex" : "d-flex d-xl-none"}
                  `}
              >
                <div className="splide__arrows d-flex gap-4">
                  <button
                    data-aos="fade-up"
                    className="splide__arrow splide__arrow--prev"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="22"
                      viewBox="0 0 11 22"
                      fill="none"
                    >
                      <path
                        d="M2 2L9.5 11L2 20"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </button>
                  <button
                    data-aos="fade-up"
                    className="splide__arrow splide__arrow--next"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="22"
                      viewBox="0 0 11 22"
                      fill="none"
                    >
                      <path
                        d="M2 2L9.5 11L2 20"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
            </Splide>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
